<div mat-dialog-content>
    <div *ngIf="data" class="main-section-box">
        <h5 class="modal_title">{{data.title}}</h5>

        <p [innerHTML]="data.subTitle"></p>

        <div *ngIf="data.fields && data.fields.length" class="fields-box-wrapper"
            [ngClass]="{'filed-box-wrapper-padding': data.fields && data.fields.length <= 3}">
            <div class="fields-box" [ngClass]="{'filed-box-height': data.fields.length <= 3}">
                <div class="field" *ngFor="let field of data.fields">{{field}}</div>
            </div>
        </div>
    </div>
</div>

<div mat-dialog-actions class="actions-btns">
    <button class="cancel-btn" mat-button (click)="closeModal()">Cancel</button>
</div>